import * as React from 'react';
import { Button, StickyCallToAction } from '@grandvisionhq/common';

const classPrefix = 'mini-cart-v2';
const ActionButtons = ({ buttonsRef , labels , links , showStickyButtons ,  })=>{
    const Buttons = /*#__PURE__*/ React.createElement(React.Fragment, null, links.cart ? /*#__PURE__*/ React.createElement(Button, {
        "aria-label": labels.toCart,
        caption: labels.toCart,
        className: `${classPrefix}__action-button`,
        href: links.cart,
        size: "small"
    }) : null, links.checkout ? /*#__PURE__*/ React.createElement(Button, {
        "aria-label": labels.toCheckout,
        caption: labels.toCheckout,
        className: `${classPrefix}__action-button`,
        href: links.checkout,
        size: "small",
        variant: "outline"
    }) : null);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__action-buttons`,
        ref: buttonsRef
    }, Buttons), showStickyButtons ? /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: Buttons
    }) : null);
};

export { ActionButtons };
//# sourceMappingURL=ActionButtons.js.map
